import { PromoProps } from "@components/PromoBanner/common"
import * as React from "react"

export default function useRenderedPromos(
  promos: PromoProps[] | undefined,
  customerCountryCode?: string,
  customerLocationFetched?: boolean
) {
  const [rendered, setRendered] = React.useState<PromoProps[]>([])

  React.useEffect(() => {
    if (!promos || !customerLocationFetched) {
      return
    }

    if (customerCountryCode === "US") {
      setRendered(
        promos.filter(
          ({ internationalOnly, usOnly }) => !!usOnly || !internationalOnly
        )
      )
    } else {
      setRendered(
        promos.filter(({ internationalOnly, specificCountries, usOnly }) => {
          if (specificCountries?.length) {
            return (
              !!customerCountryCode &&
              specificCountries.includes(customerCountryCode)
            )
          }
          return !usOnly || !!internationalOnly
        })
      )
    }
  }, [promos, customerCountryCode, customerLocationFetched])

  return rendered
}
